export class Seat {
  constructor(params) {
    this.params = params;
    this.seatId = `${this.params.row}-${this.params.coll}`;
    this.template = "<div class='tc-section--seat' />";
    this.render();
  }

  render() {
    if (this.params.seat) {
      this.el = $(this.template);
      const x = `${this.params.x * this.params.width - this.params.width}px`;
      const y = `${this.params.y * this.params.height - this.params.height}px`;

      this.el.css({
        left: x,
        top: y,
      });

      if (this.params.color) {
        this.el[0].style.setProperty("--seat-color", this.params.color);
      }

      this.el.appendTo(this.params.container);

      this.el
        .attr({
          "data-status": this.params.seat.status,
          "data-type": this.params.seat.type,
          "data-ticket-type-id": this.params.seat.ticket_type_id,
          "data-selected": false,
          "data-coll": this.params.coll,
          "data-row": this.params.row
        })
        .data({
          coll: this.params.coll,
          row: this.params.row,
        });

      this.params.seat.el = this.el;
    }

    return this;
  }
}

export default function seatsFactory(fragment, seat, width, height) {
  return new Seat({
    seat,
    x: seat.x,
    y: seat.y,
    row: seat.row,
    coll: seat.seat,
    width,
    height,
    container: fragment,
    color: seat.color,
  });
}

window.SeatsFactory = seatsFactory;
